import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b184e408"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, [
  /*#__PURE__*/_createElementVNode("p", { style: {"margin":"10px 0px"} }, "触点报名审核")
], -1))
const _hoisted_2 = { class: "auditTitle" }
const _hoisted_3 = {
  class: "titleItem",
  style: {"border":"1px dashed #ffe58f","background":"#fffbe6"}
}
const _hoisted_4 = {
  class: "number",
  style: {"color":"#faad14"}
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { style: {"color":"#666666"} }, "已报名人数", -1))
const _hoisted_6 = {
  class: "titleItem",
  style: {"border":"1px dashed #b7eb8f","background":"#f6ffed"}
}
const _hoisted_7 = {
  class: "number",
  style: {"color":"#52c41a"}
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { style: {"color":"#666666"} }, "已通过", -1))
const _hoisted_9 = {
  class: "titleItem",
  style: {"border":"1px dashed #ffa39e","background":"#fff1f0"}
}
const _hoisted_10 = {
  class: "number",
  style: {"color":"#ff4d4f"}
}
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { style: {"color":"#666666"} }, "待审核", -1))
const _hoisted_12 = { class: "container" }
const _hoisted_13 = { style: {"padding":"0 20px"} }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "formItem" }, "领取时间", -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "formItem" }, "审核人", -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "formItem" }, "审核时间", -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "formItem" }, "审核状态", -1))
const _hoisted_18 = { style: {"margin-top":"20px","background":"#fff","padding":"0 30px 20px","border-radius":"4px"} }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"height":"10px"} }, null, -1))
const _hoisted_20 = { class: "serialNumber" }
const _hoisted_21 = { class: "terminalNameContainer" }
const _hoisted_22 = {
  class: "terminalNameBox longBox",
  style: {"color":"#ccc"}
}
const _hoisted_23 = ["title"]
const _hoisted_24 = { key: 0 }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "auditClass" }, null, -1))
const _hoisted_26 = { key: 1 }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "rejectClass" }, null, -1))
const _hoisted_28 = { key: 2 }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "passAudit" }, null, -1))
const _hoisted_30 = { key: 0 }
const _hoisted_31 = ["onClick"]
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { href: "javascript:" }, " 审核详情 ", -1))
const _hoisted_33 = [
  _hoisted_32
]
const _hoisted_34 = { style: {"display":"flex","justify-content":"space-between","margin-top":"20px"} }
const _hoisted_35 = { style: {"margin":"0 10px"} }
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "auditTitleDetail" }, [
  /*#__PURE__*/_createElementVNode("span", { style: {"color":"#00ced1","font-size":"21px","font-weight":"700","padding":"0 18px"} }, "|"),
  /*#__PURE__*/_createElementVNode("span", { style: {"padding":"8px 0px"} }, "审核详情")
], -1))
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"width":"90%","height":"1px","background":"#d3d3d3","position":"absolute","left":"5%"} }, null, -1))
const _hoisted_38 = { class: "modalContainer" }
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "confirmAuditDetail" }, [
  /*#__PURE__*/_createElementVNode("span", { style: {"color":"#00ced1","font-size":"21px","font-weight":"700","padding":"0 18px"} }, "|"),
  /*#__PURE__*/_createElementVNode("span", { style: {"padding":"9px 0px","margin":"0px -13px"} }, "审核确认提示")
], -1))
const _hoisted_40 = { class: "auditModalContainer" }
const _hoisted_41 = { class: "auditBtn" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_range_picker = _resolveComponent("a-range-picker")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_SearchOutlined = _resolveComponent("SearchOutlined")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_SyncOutlined = _resolveComponent("SyncOutlined")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_table = _resolveComponent("a-table")!
  const _component_a_pagination = _resolveComponent("a-pagination")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_a_modal, {
      class: "auditModal",
      visible: $data.visible,
      "onUpdate:visible": _cache[6] || (_cache[6] = ($event: any) => (($data.visible) = $event)),
      confirmLoading: _ctx.confirmLoading,
      keyboard: "true",
      closable: true,
      centered: "",
      width: "1200px",
      footer: null
    }, {
      default: _withCtx(() => [
        _hoisted_1,
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("p", _hoisted_4, _toDisplayString($data.finishedNumber), 1),
            _hoisted_5
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("p", _hoisted_7, _toDisplayString($data.passNumber), 1),
            _hoisted_8
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("p", _hoisted_10, _toDisplayString($data.auditNumber), 1),
            _hoisted_11
          ])
        ]),
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("div", _hoisted_13, [
            _createVNode(_component_a_form, {
              model: $data.formState,
              "label-col": { style: { width: '90px' } }
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_row, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_col, {
                      span: 7,
                      class: "formCol"
                    }, {
                      default: _withCtx(() => [
                        _hoisted_14,
                        _createVNode(_component_a_range_picker, {
                          disabledDate: _ctx.disabledDate,
                          value: $data.formState.rangePicker,
                          "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => (($data.formState.rangePicker) = $event)),
                          onCalendarChange: _ctx.onCalendarChange,
                          onOpenChange: _ctx.onOpenChange,
                          allowClear: ""
                        }, null, 8, ["disabledDate", "value", "onCalendarChange", "onOpenChange"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_col, { span: 1 }),
                    _createVNode(_component_a_col, {
                      span: 7,
                      class: "formCol"
                    }, {
                      default: _withCtx(() => [
                        _hoisted_15,
                        _createVNode(_component_a_input, {
                          value: $data.formState.checkName,
                          "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => (($data.formState.checkName) = $event)),
                          placeholder: "请输入...",
                          allowClear: "",
                          class: "input"
                        }, null, 8, ["value"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_col, { span: 1 }),
                    _createVNode(_component_a_col, {
                      span: 7,
                      class: "formCol"
                    }, {
                      default: _withCtx(() => [
                        _hoisted_16,
                        _createVNode(_component_a_range_picker, {
                          disabledDate: _ctx.disabledDate,
                          value: $data.formState.auditPicker,
                          "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => (($data.formState.auditPicker) = $event)),
                          onCalendarChange: _ctx.onCalendarChange,
                          onOpenChange: _ctx.onOpenChange,
                          allowClear: ""
                        }, null, 8, ["disabledDate", "value", "onCalendarChange", "onOpenChange"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_row, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_col, { span: 7 }, {
                      default: _withCtx(() => [
                        _hoisted_17,
                        _createVNode(_component_a_select, {
                          value: $data.formState.taskType,
                          "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => (($data.formState.taskType) = $event)),
                          placeholder: "请选择...",
                          options: $data.taskTypeOptions,
                          allowClear: ""
                        }, null, 8, ["value", "options"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_col, { span: 1 }),
                    _createVNode(_component_a_col, {
                      span: 5,
                      style: {"padding":"40px 0 0 0"}
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_button, {
                          type: "primary",
                          onClick: $options.onSearch
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_SearchOutlined, { style: {"font-size":"14px","position":"relative","top":"1px"} }),
                            _createTextVNode(" 搜索")
                          ]),
                          _: 1
                        }, 8, ["onClick"]),
                        _createVNode(_component_a_button, {
                          onClick: $options.onReset,
                          style: {"margin-left":"15px"}
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_SyncOutlined, { style: {"font-size":"14px","position":"relative","top":"1px"} }),
                            _createTextVNode("重置")
                          ]),
                          _: 1
                        }, 8, ["onClick"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["model"])
          ]),
          _createElementVNode("div", _hoisted_18, [
            _hoisted_19,
            _createElementVNode("div", null, [
              _createVNode(_component_a_table, {
                rowKey: "id",
                columns: $data.columns,
                "data-source": $data.data,
                pagination: false,
                loading: _ctx.loading,
                size: $data.batchStyle
              }, {
                serialNumber: _withCtx(({ index }) => [
                  _createElementVNode("span", _hoisted_20, _toDisplayString(index + 1), 1)
                ]),
                auditUserName: _withCtx(({ record }) => [
                  _createElementVNode("div", _hoisted_21, [
                    _createElementVNode("div", null, [
                      _createElementVNode("div", _hoisted_22, _toDisplayString(record.auditUserName), 1),
                      _createElementVNode("div", {
                        class: "terminalNameBox longBox",
                        style: {"color":"#ccc"},
                        title: record.auditTime
                      }, _toDisplayString(record.auditTime), 9, _hoisted_23)
                    ])
                  ])
                ]),
                auditStatus: _withCtx(({ record }) => [
                  (record.auditStatus == 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                        _hoisted_25,
                        _createTextVNode(" 待审核 ")
                      ]))
                    : (record.auditStatus == 1)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                          _hoisted_27,
                          _createTextVNode(" 已驳回 ")
                        ]))
                      : (record.auditStatus == 2)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                            _hoisted_29,
                            _createTextVNode(" 已通过 ")
                          ]))
                        : _createCommentVNode("", true)
                ]),
                handle: _withCtx(({ record }) => [
                  (record.auditStatus == 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                        _createVNode(_component_a_button, {
                          type: "primary",
                          size: "small",
                          onClick: ($event: any) => ($options.passAudit(record))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("通过")
                          ]),
                          _: 2
                        }, 1032, ["onClick"]),
                        _createVNode(_component_a_button, {
                          style: {"margin-left":"5px"},
                          size: "small",
                          onClick: ($event: any) => ($options.rejectAudit(record))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("驳回")
                          ]),
                          _: 2
                        }, 1032, ["onClick"])
                      ]))
                    : (_openBlock(), _createElementBlock("div", {
                        key: 1,
                        onClick: ($event: any) => ($options.alertAudit(record))
                      }, _hoisted_33, 8, _hoisted_31))
                ]),
                _: 1
              }, 8, ["columns", "data-source", "loading", "size"])
            ]),
            _createElementVNode("div", _hoisted_34, [
              _createElementVNode("div", null, [
                _createTextVNode(" 共"),
                _createElementVNode("span", _hoisted_35, _toDisplayString($data.total), 1),
                _createTextVNode("条数据 ")
              ]),
              _createVNode(_component_a_pagination, {
                "show-size-changer": "",
                "show-quick-jumper": "",
                current: $data.pageCurrent,
                "onUpdate:current": _cache[4] || (_cache[4] = ($event: any) => (($data.pageCurrent) = $event)),
                pageSize: $data.pageSize,
                "onUpdate:pageSize": _cache[5] || (_cache[5] = ($event: any) => (($data.pageSize) = $event)),
                total: $data.total,
                onShowSizeChange: $options.onShowSizeChange,
                "page-size-options": ['5', '10', '15', '20']
              }, null, 8, ["current", "pageSize", "total", "onShowSizeChange"])
            ])
          ])
        ])
      ]),
      _: 1
    }, 8, ["visible", "confirmLoading"]),
    _createVNode(_component_a_modal, {
      class: "auditDetail",
      visible: $data.detailVisiable,
      "onUpdate:visible": _cache[7] || (_cache[7] = ($event: any) => (($data.detailVisiable) = $event)),
      centered: "",
      width: "300px",
      footer: null
    }, {
      default: _withCtx(() => [
        _hoisted_36,
        _hoisted_37,
        _createElementVNode("div", _hoisted_38, [
          _createElementVNode("p", null, "审核人：" + _toDisplayString($data.auditName), 1),
          _createElementVNode("p", null, "审核时间：" + _toDisplayString($data.auditTime), 1)
        ])
      ]),
      _: 1
    }, 8, ["visible"]),
    _createVNode(_component_a_modal, {
      class: "auditConfirm",
      visible: $data.auditVisiable,
      "onUpdate:visible": _cache[8] || (_cache[8] = ($event: any) => (($data.auditVisiable) = $event)),
      centered: "",
      width: "350px",
      footer: null
    }, {
      default: _withCtx(() => [
        _hoisted_39,
        _createElementVNode("div", _hoisted_40, _toDisplayString($data.auditMsg), 1),
        _createElementVNode("div", _hoisted_41, [
          _createVNode(_component_a_button, {
            style: {"margin-left":"5px"},
            onClick: $options.cancelAudit
          }, {
            default: _withCtx(() => [
              _createTextVNode("取消")
            ]),
            _: 1
          }, 8, ["onClick"]),
          _createVNode(_component_a_button, {
            type: "primary",
            onClick: $options.confirmAudit
          }, {
            default: _withCtx(() => [
              _createTextVNode("确认")
            ]),
            _: 1
          }, 8, ["onClick"])
        ])
      ]),
      _: 1
    }, 8, ["visible"])
  ], 64))
}